import React, {useEffect, useState} from "react";
import {Button, Checkbox, Spin, message} from "antd";

import './TermosCondicoes.scss';
import TermosCondicoesText from "./TermosCondicoesText";
import { organizacaoService } from "../../shared/services/http/OrganizacaoService";
import {getUser} from "../../shared/services/UserService";
import {termosECondicoes} from "../../shared/services/TermosECondicoesService";

export default function TermosCondicoes() {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [organizacao, setOrganizacao] = useState({})
  const [accepting, setAccepting] = useState(false)
  const [declining, setDeclining] = useState(false)

  useEffect(() => getOrganization(),[])

  function getOrganization() {
    setLoading(true)
    organizacaoService.getById(getUser().id)
      .then(organization => setOrganizacao(organization))
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }

  function accept() {
    setAccepting(true)
    organizacaoService.acceptTermsAndConditions()
      .then(() => getOrganization())
      .catch((error) => message.error(error))
      .finally(() => setAccepting(false))
  }

  function decline() {
    setDeclining(true)
    organizacaoService.declineTermsAndConditions()
      .then(() => getOrganization())
      .catch((error) => message.error(error))
      .finally(() => setDeclining(false))
  }

  const { Aceitou } = termosECondicoes
  const isAccepted = organizacao.termosECondicoes === Aceitou.Enum

  function StatusBanner() {
    if (error) return null

    if (isAccepted) {
      return (
        <div className="termos-banner termos-banner--aceito">
          Você aceitou os Termos de Uso e Condições.
        </div>
      )
    }

    return (
      <div className="termos-banner termos-banner--pendente">
        É necessário aceitar os Termos e Condições de Uso para continuar utilizando o sistema Upgas.
        <br />
        No fim da página, após a leitura, confirmar o aceite.
      </div>
    )
  }

  function FooterContent() {
    if (error) return <p>Falha ao carregar</p>

    return (
      <div className="termos-footer-content">
        <p className="termos-footer-text">
          Este termo define as condições de uso da plataforma Upgas e o compromisso de fornecimento entre revendedores e clientes.<br />
          Leia atentamente antes de confirmar — ao aceitar, você concorda integralmente com as regras e responsabilidades descritas no documento.
        </p>
        <Checkbox checked={isAccepted} disabled={isAccepted}>
          Li e aceito os Termos de Uso e Condições
        </Checkbox>
        {!isAccepted && (
          <div>
            <Button
              type="primary"
              className="termos-confirmar-btn"
              loading={accepting}
              disabled={accepting || declining}
              onClick={() => accept()}
            >
              Confirmar aceite
            </Button>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="termos-condicoes">
      <StatusBanner />

      <div className="termos-content-card">
        <TermosCondicoesText />

        <div className="termos-atencao">
          <p className="termos-atencao__titulo">Atenção</p>
          <p className="termos-atencao__texto">
            POR FAVOR, LEIA COM ATENÇÃO ESTES TERMOS ANTES DE ACESSAR OU USAR OS SERVIÇOS.
          </p>
          <p className="termos-atencao__texto">
            O REVENDEDOR RECONHECE QUE LEU, ENTENDEU, ANALISOU E ACEITOU AS CONDIÇÕES DE USO, MEDIANTE SUA CONCORDÂNCIA CLICANDO NO BOTÃO "ACEITO".
          </p>
          <p className="termos-atencao__texto">
            TERMOS E CONDIÇÕES GERAIS DE CONTRATAÇÃO DA UPGAS TECNOLOGIA.
          </p>
        </div>
      </div>

      <div className="termos-footer-card">
        <Spin spinning={loading}>
          <FooterContent />
        </Spin>
      </div>
    </div>
  )
}
